export enum ToastType {
  success = "success",
  successfullyDeleted = "successfully-deleted",
  itemNotFound = "item-not-found",
  error = "error",
}

export interface IToast {
  id: string;
  text: string;
  prefixText?: string;
  suffixText?: string;
  itemName?: string;
  newItemName?: string;
  type: ToastType;
}

export interface IToastConfig { 
  text: string;
  prefixText?: string;
  suffixText?: string;
  itemName?: string;
  newItemName?: string;
  timeout?: number; 
}